"use strict";
const { isCompleteSKU } = require('./properties');
const ensureCartRows = entity => ({
    ...entity,
    cartRows: (entity.cartRows || []).filter(cartRow => (cartRow.quantity || 0) > 0),
});
const getSKUByName = (cartRow, skuName) => {
    if (!skuName) {
        return undefined;
    }
    const newSKU = cartRow.pricedArticle?.stockKeepingUnits?.find(sku => sku.name !== undefined && sku.name === skuName);
    return newSKU;
};
const ensureSKU = entity => {
    const ensuredEntity = {
        ...entity,
    };
    ensuredEntity.cartRows = (ensuredEntity.cartRows || []).map(cartRow => {
        if (cartRow.orderedSKU && !isCompleteSKU(cartRow.orderedSKU)) {
            return {
                ...cartRow,
                orderedSKU: getSKUByName(cartRow, cartRow.orderedSKU.name) || cartRow.orderedSKU,
            };
        }
        return cartRow;
    });
    return ensuredEntity;
};
module.exports = entity => ensureSKU(ensureCartRows(entity));
